import { useQuery } from '@tanstack/react-query';

import { supabase } from '../../lib/supabase.js';
import { aiKpisResponseSchema } from './schemas.js';
import type { AiKpisResponse } from './types.js';

export const AI_ANALYTICS_QUERY_KEYS = {
  kpis: (periodDays: number) => ['ai-analytics', 'kpis', periodDays] as const,
};

export function useAiKpis(periodDays = 30) {
  return useQuery({
    queryKey: AI_ANALYTICS_QUERY_KEYS.kpis(periodDays),
    staleTime: 60_000,
    queryFn: async (): Promise<AiKpisResponse> => {
      const { data, error } = await supabase.rpc(
        'admin_ai_kpis' as never,
        {
          p_period_days: periodDays,
        } as never,
      );

      if (error) throw new Error(error.message);
      return aiKpisResponseSchema.parse(data);
    },
  });
}
